import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Load, Fetch } from '@app/store/reducers/data.reducer';
import { AuthListener } from "@app/store/selectors/data.selectors";

import { Blocks } from '@app/core/Elements/Blocks';
import { Progress } from '@app/screens/Dashboard/Progress';
import { UnityView } from '@app/core/Elements/Unity';

interface Props { }
export const DashboardScreen: React.FC<Props> = () =>
{
    const dispatch = useDispatch();
    const [popup, setPopup] = useState(false);
    const [overlay, setOverlay] = useState(true);

    useEffect(() =>
    {
        AuthListener();
        dispatch(Load(null));

        var w: any = window;
        w.LuaInit = onLuaInit;
        w.LuaEvent = onLuaEvent;
    }, []);

    const onLuaInit = () =>
    {
        console.log("INIT");
    }
    const onLuaEvent = (ev: string, data: any) =>
    {
        if (ev == "SET_OVERLAY" && data == "ON")
            setOverlay(true);
        if (ev == "SET_OVERLAY" && data == "OFF")
            setOverlay(false);
        if (ev == "SET_POPUP" && data == "ON")
            setPopup(true);
        if (ev == "SET_POPUP" && data == "OFF")
            setPopup(false);
        if (ev == "SET_STAGE")
            dispatch(Fetch({ stageId: data }));
        if (ev == "OPEN_TUTORIAL")
            window.open("https://watch.screencastify.com/v/LI4FWWs1qG4iyv0nwYgU", "_blank");
    }

    return (
        <>
            <div className="dashboard">
                {popup == true && overlay == false && <div className="overlay"></div>}
                <div className={overlay ? "unity" : "unity-small"}><UnityView /></div>
                {!overlay && <div className="blocks">
                    <Progress />
                    <Blocks />
                </div>}
            </div>
        </>
    );
};
